export default "__VITE_PUBLIC_ASSET__7e15f699__"